"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var ArrayParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(ArrayParser, _Parser_1$Parser);

  function ArrayParser(members) {
    var _this;

    _classCallCheck(this, ArrayParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrayParser).call(this));
    _this.members = members;
    return _this;
  }

  _createClass(ArrayParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (!Array.isArray(input)) {
        return new ValidationResult_1.ValidationError(ArrayParser.NOT_AN_ARRAY_ERROR);
      }

      var ret = []; //tslint:disable:prefer-for-of

      for (var i = 0; i < input.length; i++) {
        var m = this.members.validate(input[i], level || ValidationLevel_1.ValidationLevel.Basic);

        if (!m.valid) {
          return m;
        }

        ret.push(m.value);
      }

      return new ValidationResult_1.ValidationSuccess(ret);
    }
  }]);

  return ArrayParser;
}(Parser_1.Parser);

exports.ArrayParser = ArrayParser;
ArrayParser.NOT_AN_ARRAY_ERROR = 'NOT_AN_ARRAY';